module.exports = __webpack_public_path__ + "static/media/isdoctorplan-obgyn1@2x.5b717583.png";